import { memo } from 'react';
import { Trans } from '@bonanza-social/i18n';
import { Text } from '@bonanza-social/moonlight';

function StatusVipProgress() {
  return (
    <Text variant="body-s" color="darkSurfacePrimary" textAlign="center">
      <Trans
        ns="status"
        i18nKey="statusVipDescription"
        components={{
          b: <Text variant="body-s-semi" color="darkSurfacePrimary" />,
        }}
      />
    </Text>
  );
}

export default memo(StatusVipProgress);
